module.exports = __webpack_public_path__ + "img/Picture5.22214132.png";